module.exports = __webpack_public_path__ + "media/images/clients/momo-3fa881d7cf7e51bc075b5dcc72fdeb61.png";